var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},_vm._l((_vm.icons),function(icon){return _c('font-awesome-icon',{key:icon.iconName,staticClass:"m-2",attrs:{"icon":icon},on:{"click":function($event){return _vm.select(icon.iconName)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e98594","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/iconPicker.vue
// module id = IeCm
// module chunks = 117 127